import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as PinIcon } from '../assets/svg/PinIcon.svg';

interface SidebarProps {
	menuList: any[];
}

const Sidebar: React.FC<SidebarProps> = ({ menuList }) => {
	const [collapsed, setCollapsed] = useState<boolean>(false);
	const [pinned, setPinned] = useState<boolean>(true);
	const navigate = useNavigate();
	const location = useLocation();

	const [showText, setShowText] = useState(!collapsed);

	useEffect(() => {
		let timeout: NodeJS.Timeout;
		if (collapsed) {
			setShowText(false);
		} else {
			timeout = setTimeout(() => setShowText(true), 300);
		}
		return () => clearTimeout(timeout);
	}, [collapsed]);

	const isSelected = (sub: any) => {
		const current = location?.pathname;
		// Exact match
		if (sub?.url === current || sub?.select === current) return true;
		
		// Check if current path starts with select path (for routes with parameters)
		if (sub?.select && current.startsWith(sub.select.split(':')[0])) {
			return true;
		}
		
		return false;
	};

	const handleMouseEnter = () => {
		if (!pinned) setCollapsed(false);
	};
	const handleMouseLeave = () => {
		if (!pinned) setCollapsed(true);
	};

	return (
		<div
			className='relative h-full flex flex-col bg-[#1e3f940a] transition-all duration-300 ease-in-out'
			style={{
				width: collapsed ? '80px' : '280px',
				minWidth: collapsed ? '80px' : '280px',
			}}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			{/* Scrollable menu */}
			<div className='flex-1 overflow-y-auto px-[10px] py-4 gray-small-scroll'>
				{menuList.map((section) => (
					<div key={section?.name || Math.random()}>
						{/* Section item */}
						<div className='grid grid-cols-[40px_1fr] gap-2 items-center py-3 px-2 mt-4 mb-2 relative'>
							<div className='flex justify-center items-center shrink-0 '>{section?.icon || <div className='w-[30px] h-[30px]'></div>}</div>
							<div
								className='transition-transform  duration-300'
								style={{
									transform: collapsed ? 'translateX(-180px)' : 'translateX(0)',
									width: '200px',
									opacity: showText ? 1 : 0,
								}}
							>
								<span className='text-gray-500 font-semibold uppercase text-sm text-[#1e4094] tracking-tight '>{section?.name}</span>
							</div>
						</div>

						{/* Menu items */}
						{section?.subMenus?.map((sub: any) => (
							<div key={sub?.name} onClick={() => navigate(sub?.url)} title={collapsed ? sub?.title : ''} className={`grid grid-cols-[40px_1fr] gap-2 items-center py-[2px] px-2   cursor-pointer `}>
								<div className={`flex justify-center items-center p-1 rounded-md ${isSelected(sub) && collapsed ? 'bg-[#ccc]' : ''}`}>{sub?.icon || <div className='w-[30px] h-[30px]'></div>}</div>
								<div
									className={`transition-transform rounded-md py-2 px-2 duration-300 ${isSelected(sub) ? 'text-white bg-[#0F2765]' : 'hover:text-white hover:bg-[#0F2765] text-gray-400'}`}
									style={{
										transform: collapsed ? 'translateX(-180px)' : 'translateX(0)',
										width: '200px',
										opacity: showText ? 1 : 0,
									}}
								>
									<span className='text-[15px] tracking-tight'>{sub?.title}</span>
								</div>
							</div>
						))}
					</div>
				))}
			</div>

			{/* Pin button */}
			<div className='absolute top-2 -right-5 w-full flex justify-center pointer-events-auto'>
				<button
					onClick={(e) => {
						e.stopPropagation();
						setPinned((prev) => {
							const newPinned = !prev;
							setCollapsed(!newPinned);
							return newPinned;
						});
					}}
					className='p-2 rounded-full border-[3px] w-10 h-10 flex items-center justify-center bg-white'
					style={{
						borderColor: pinned ? '#0F2765' : '#aaa',
						transform: `translateX(${collapsed ? '17px' : '117px'})`,
						transition: 'transform 0.3s',
					}}
					title={pinned ? 'Затвори мени' : 'Отвори мени'}
				>
					<PinIcon className={`transition-transform duration-300 ${pinned ? 'rotate-0' : 'rotate-45 opacity-60'}`} />
				</button>
			</div>
		</div>
	);
};

export default Sidebar;
